<template>
  <section id="main-box">
    <div class="page-content" :class="{bottom:list.length > 0}">
      <div class="table-box layui-body" style="left:0;">

        <div class="xblock layui-form">
          <button class="layui-btn xblock-row">刷新页面</button>
          <span class="x-right xblock-row" v-text="'　共有数据：'+count+ '条'"></span>
          <div class="clear-both"></div>
        </div>

        <table class="layui-table layui-form">
          <thead>
            <tr>
              <th>图片</th>
              <th>用户</th>
              <th>来源</th>
              <th>标题</th>
              <th>链接</th>
              <th>状态</th>
              <th>时间</th>
            </tr>
          </thead>
          <tbody v-viewer>
            <tr v-for="(item,index) in list">
              <td>
                <div class="table_img">
                  <img :src="item.image">
                </div>
              </td>
              <td v-text="item.uid"></td>
              <td>
                <i v-if="item.type == 'shopee'">shopee</i>
                <i v-else-if="item.type == 'pinduoduo'">拼多多</i>
                <i v-else-if="item.type == 'taobao'">淘宝</i>
                <i v-else-if="item.type == 'tmall'">天猫</i>
                <i v-else-if="item.type == '1688'">1688</i>
                <i v-else-if="item.type == 'duoduopifa'">多多批发</i>
                <i v-else-if="item.type == 'aliexpress'">速卖通</i>
                <i v-else-if="item.type == 'yiwugo'">义乌购</i>
              </td>
              <td style="min-width: 150px;max-width:400px;">
                <i v-if="item.is_repeat" class="status-box-red" style="padding:2px;">重复采集</i>
                <i v-text="item.name"></i>
              </td>
              <td>
                <div class="openabox" style="overflow: hidden;">
                  <a :href="item.origin" target="_blank" class="onlyTwoRow Alabel" style="width: 250px;word-break:break-all;"
                    v-text="item.origin"></a>
                </div>
              </td>
              <td>
                <div style="width: 80px;">
                  <i v-if="item.is_upload == 1" class="status-box status-box-orange">已发布</i>
                  <i v-else class="status-box status-box-green">未发布</i>
                </div>
              </td>
              <td v-text="item.created_at"></td>
            </tr>
          </tbody>
        </table>

        <!-- transition -->
        <K-Transition :isLoding="isLoding" v-if="isLoding || list.length < 1" style="margin-top: 16px;"></K-Transition>

      </div>

      <!-- 分页 -->
      <div class="page-box"><div id="pagebox" class="pagebox"></div></div>

      <!-- loading -->
      <K-Loading v-if="loading"></K-Loading>

      <!-- toast -->
      <K-Toast :Toast="Toast" @ChangeToast="ChangeToast"></K-Toast>

    </div>
  </section>
</template>

<script>
  var self, form, layer, laypage, isRefresh;
  import axios from 'axios'
  import Loading from '@/components/common/Loading.vue'
  import Toast from '@/components/common/Toast.vue'
  import Transition from '@/components/common/Transition.vue'
  import Confirm from '@/components/common/Confirm.vue'
  export default {
    name: 'Promote',
    components: {
      'K-Loading': Loading,
      'K-Toast': Toast,
      'K-Transition': Transition,
      'K-Confirm': Confirm,
    },
    data() {
      return {
        isLoding: true,
        id: null,
        itemid: null,
        loading: false,
        Toast: {
          state: false,
          type: 0,
          txt: null
        },
        Confirm: {
          state: false,
          txt: null
        },
        page: 1,
        count: 0,
        page_num:20,
        isloding: false,
        boxTop: 0,
        list: [],
        shops: [],
        merchants: [],
      }
    },
    updated() {
      if (form) {
        form.render();
      }
    },
    watch: {
      $route: {
        handler(nv, ov) {
          if (nv.query.id) {
            if (self.id != nv.query.id) {
              self.id = nv.query.id;
              self.list = [];
              self.ProductList(nv.query.id);
            }
          }
        }
      },
      deep: true
    },
    mounted() {
      self = this;
      let id = self.$route.query.id; //采集商品ID
      if (id) {
        localStorage.setItem("ExShopee_HistoryURL", "Col"); //缓存一级导航URL
        localStorage.setItem("ExShopee_NavSubIx", 1); //缓存二级导航索引
      }

      self.boxTop = document.documentElement.clientHeight / 2 - 97;

      layui.use(['form', 'layer', 'laydate', 'laypage'], function() {
        form = layui.form;
        layer = layui.layer;
        laypage = layui.laypage;

        if (id) {
          self.ProductList(id);
        } else {
          self.ProductList();
        }

        //全选
        form.on('checkbox(cxall)', function(data) {
          var child = $(".cx-box input[type='checkbox']");
          var status = data.elem.checked;
          child.each(function(index, item) {
            item.checked = data.elem.checked;
            self.list[index].active = status;
          });
          form.render('checkbox');
        });

        //单选
        form.on('checkbox(cx)', function(data) {
          let ix = data.elem.dataset.index;
          let status = data.elem.checked;
          self.list[ix].active = status;
          form.render('checkbox');
        });

        //单选
        $("#main-box").on("click", '.cx-box', function(e) {
          var ix = $(this).attr("data-ix");
          if (self.list[ix].active) {
            self.list[ix].active = false;
          } else {
            self.list[ix].active = true;
          }
          form.render('checkbox');
        });

      });

    },
    methods: {
      ToastFun(type, txt) {
        self.Toast.state = true;
        self.Toast.type = type;
        self.Toast.txt = txt;
      },
      ChangeToast() {
        self.Toast.state = false;
      },
      ProductList(id) {
        let param = new URLSearchParams()
        if (id) {
          param.append('id', id)
        }
        param.append('num', self.page_num)
        self.isLoding = true;
        axios({
          method: 'post',
          url: self.GetServerUrl() + '/admin_collection_list/?page=' + self.page,
          data: param,
          headers: {
            'token': localStorage.getItem("ExShopee_token")
          }
        }).then(function(json) {
          self.isLoding = false;
          var json = json.data;
          if (json.code == 200) {
            var datas = json.datas;
            var list = datas.list;
            if (datas.page) {
              for (let i in list) {
                list[i].active = false;
              }
              self.list = list;
              self.total = datas.total;
              if(id){
                self.GoToPage("/Col");
              }

              self.count = datas.page.count;
              self.ShowPage(self, laypage, "ProductList"); //分页
              $('.pagebox').show();
            }
          } else if (json.code == 401) {
            layer.alert('请先前往登录！', {
              title: "ExShopee",
              closeBtn: 0
            }, function() {
              layer.closeAll();
              self.GoToPage("/");
            });
          } else {
            self.list = [];
            $('.pagebox').hide();

            //自动换页
            if (self.page > 1) {
              self.page -= 1;
              self.ProductList();
            }
          }
        }).catch(function(error) {
          self.isLoding = false;
          self.ToastFun(2, error); //弹窗提醒
        })
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  td {
    padding: 18px 15px;
  }

  .country_select {
    width: 150px;
  }

  .promote-url {
    padding-left: 10px;
    line-height: 40px;
  }
</style>



// WEBPACK FOOTER //
// src/components/admin/product/Col.vue